var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0584 0C25.9043 0 25.7509 0.0190909 25.5988 0.0565909L10.412 3.85295C9.50109 4.08136 8.86359 4.8975 8.86359 5.83773V25.9091C8.86359 27.4132 7.64041 28.6364 6.13632 28.6364C4.63223 28.6364 3.40905 27.4132 3.40905 25.9091C3.40905 24.405 4.63223 23.1818 6.13632 23.1818C6.31973 23.1818 6.50382 23.2002 6.68314 23.2364C7.052 23.312 7.41132 23.0727 7.487 22.7032C7.56132 22.3343 7.32268 21.9743 6.95382 21.9C6.68518 21.8461 6.41041 21.8182 6.13632 21.8182C3.88018 21.8182 2.04541 23.653 2.04541 25.9091C2.04541 28.1652 3.88018 30 6.13632 30C8.39246 30 10.2272 28.1652 10.2272 25.9091V5.83773C10.2272 5.52477 10.44 5.25205 10.7434 5.17636L25.9281 1.38068C26.2663 1.29614 26.5909 1.55932 26.5909 1.89614V4.93432L12.0934 8.88818C11.73 8.98773 11.5152 9.36205 11.6147 9.72545C11.6972 10.0282 11.9727 10.2273 12.272 10.2273C12.332 10.2273 12.392 10.2191 12.452 10.2027L26.5909 6.34705V21.8182C26.5909 23.3223 25.3677 24.5455 23.8636 24.5455C22.3595 24.5455 21.1363 23.3223 21.1363 21.8182C21.1363 20.3141 22.3595 19.0909 23.8636 19.0909C24.047 19.0909 24.2311 19.1093 24.4104 19.1455C24.7772 19.2218 25.1386 18.9811 25.2143 18.6123C25.2886 18.2434 25.05 17.8834 24.6811 17.8091C24.4125 17.7552 24.1377 17.7273 23.8636 17.7273C21.6075 17.7273 19.7727 19.562 19.7727 21.8182C19.7727 24.0743 21.6075 25.9091 23.8636 25.9091C26.1197 25.9091 27.9545 24.0743 27.9545 21.8182V1.89614C27.9545 0.850909 27.1036 0 26.0584 0Z",
    fill: "url(#paint0_linear_2146_13198)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2146_13198",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.cdafec94.svg";
export { ForwardRef as ReactComponent };